import { css } from '@emotion/css';

export const questionItemStyles = css`
  .action-menu-btn {
    opacity: 0;
  }

  .action-menu-btn.open {
    opacity: 1;
  }

  :hover {
    .action-menu-btn {
      opacity: 1;
    }
  }
`;
